<template>
  <b-card
    no-body
    class="table-approvals"
  >
    <b-table
      :items="approvals"
      responsive
      :fields="fields"
      class="mb-0"
      selectable
      select-mode="single"
      @row-selected="onApprovalSelected"
    >
      <template #cell(numero)="data">
        <div class="d-flex align-items-center">
          <span v-if="data.item.numero">
            {{data.item.numero}}
          </span>
          <span v-else>
            --
          </span>
        </div>
      </template>
      <template #cell(nombreAprobacion)="data">
        <div class="">
          <div class="font-weight-bolder">
            {{ data.item.nomnbreEjecucion }}
          </div>
          <div class="font-small-2 text-muted">
            {{ data.item.nombreAprobacion }}
          </div>
        </div>
      </template>
      <template #cell(unidadNombre)="data">
        <div class="d-flex flex-column">
          <b-badge variant="light-info" v-if="data.item.unidadNombre">
            {{ data.item.unidadNombre }}
          </b-badge>
          <b-badge v-else variant="light-secondary">
            --
          </b-badge>
        </div>
      </template>
      <template #cell()="data">
        <b-progress
          :value=" data.item.numeroPaso"
          :max="data.item.totalPasos"
          variant="primary"
          striped
        />
        <div class="font-small-2 text-muted text-center">
          {{ data.item.numeroPaso }} / {{data.item.totalPasos}}
        </div>
      </template>
      <template #cell(fechaInicioPaso)="data">
        <div class="d-flex align-items-center">
          <span class="font-weight-bolder mr-1">
            {{ data.item.fechaInicioPaso | dateFormat }}
          </span>
        </div>
      </template>
    </b-table>
  </b-card>
</template>
<script>
export default {
  data() {
    return {
      rows: this.approvals.length,
      currentPage: 1,
      fields: [
        { key: 'numero', label: 'Número' },
        { key: 'nombreAprobacion', label: 'Nombre' },
        { key: 'unidadNombre', label: 'Unidad' },
        { key: 'totalPasos', label: 'Aprobadores' },
        { key: 'fechaInicioPaso', label: 'Creado' },
      ]
    };
  },
  methods: {
    onApprovalSelected(row) {
      const flow = row[0];
      this.$emit('select', flow);
    }
  },
  props: {
    approvals: { type: Array }
  }
};
</script>
<style lang="scss" scoped>
  .table-approvals {
    max-height: 500px;
    overflow-y: scroll;
  }
</style>
